/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StripePlanBean', 'model/StripeSubscriptionItemMetadataBean', 'model/StripeTaxRateBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StripePlanBean'), require('./StripeSubscriptionItemMetadataBean'), require('./StripeTaxRateBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.StripeSubscriptionItemBean = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.StripePlanBean, root.BpmbuildProductionappspotcom.StripeSubscriptionItemMetadataBean, root.BpmbuildProductionappspotcom.StripeTaxRateBean);
  }
}(this, function(ApiClient, StripePlanBean, StripeSubscriptionItemMetadataBean, StripeTaxRateBean) {
  'use strict';

  /**
   * The StripeSubscriptionItemBean model module.
   * @module model/StripeSubscriptionItemBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeSubscriptionItemBean</code>.
   * @alias module:model/StripeSubscriptionItemBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeSubscriptionItemBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeSubscriptionItemBean} obj Optional instance to populate.
   * @return {module:model/StripeSubscriptionItemBean} The populated <code>StripeSubscriptionItemBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('subscription'))
        obj.subscription = ApiClient.convertToType(data['subscription'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('object'))
        obj._object = ApiClient.convertToType(data['object'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Date');
      if (data.hasOwnProperty('stripeSubscriptionItemId'))
        obj.stripeSubscriptionItemId = ApiClient.convertToType(data['stripeSubscriptionItemId'], 'String');
      if (data.hasOwnProperty('tax_rates'))
        obj.taxRates = ApiClient.convertToType(data['tax_rates'], [StripeTaxRateBean]);
      if (data.hasOwnProperty('metadata'))
        obj.metadata = StripeSubscriptionItemMetadataBean.constructFromObject(data['metadata']);
      if (data.hasOwnProperty('billingThresholdUsageGte'))
        obj.billingThresholdUsageGte = ApiClient.convertToType(data['billingThresholdUsageGte'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('quantity'))
        obj.quantity = ApiClient.convertToType(data['quantity'], 'String');
      if (data.hasOwnProperty('plan'))
        obj.plan = StripePlanBean.constructFromObject(data['plan']);
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {String} subscription
   */
  exports.prototype.subscription = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} _object
   */
  exports.prototype._object = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {String} stripeSubscriptionItemId
   */
  exports.prototype.stripeSubscriptionItemId = undefined;

  /**
   * @member {Array.<module:model/StripeTaxRateBean>} taxRates
   */
  exports.prototype.taxRates = undefined;

  /**
   * @member {module:model/StripeSubscriptionItemMetadataBean} metadata
   */
  exports.prototype.metadata = undefined;

  /**
   * @member {String} billingThresholdUsageGte
   */
  exports.prototype.billingThresholdUsageGte = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} quantity
   */
  exports.prototype.quantity = undefined;

  /**
   * @member {module:model/StripePlanBean} plan
   */
  exports.prototype.plan = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/StripeSubscriptionItemBean.js